import { Tile, Stat, TileLink } from "./Tile";

export const OrdersTile = ({ orders, tone, index }) => (
  <Tile id="orders" index={index} tone={tone} kicker="Tile 5 · Shopify" title="Shopify orders"
    action={<TileLink to="/admin/orders" testid="orders-open-list">All orders</TileLink>}>
    <div className="grid grid-cols-2 gap-2">
      <Stat testid="orders-open" label="Open" value={orders.open} />
      <Stat testid="orders-to-print" label="To print" value={orders.to_print} tone={orders.to_print ? "amber" : undefined} />
      <Stat testid="orders-printing" label="Printing" value={orders.printing} />
      <Stat testid="orders-shipped" label="Shipped (30 days)" value={orders.shipped_30d} />
    </div>
    <p className="mt-2 text-[11px] text-muted-foreground">Counts are {orders.unit}.</p>
    <div className="mt-auto flex flex-wrap gap-2 pt-2">
      <TileLink to="/admin/queue" testid="orders-open-queue">Print queue</TileLink>
      <TileLink to="/admin/spend-gate" testid="orders-open-spend-gate">Spend gate</TileLink>
    </div>
  </Tile>
);
